// TODO: implement main App component with routing and providers
import { Toaster } from 'react-hot-toast'
import { AppProvider } from './providers'
import { ClubProvider } from '@/features/clubs/context/ClubContext'
import { routes } from './router'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { NavigationWrapper, ClubCacheManager } from '@/components'

export default function App() {
  return (
    <div>
      <Toaster 
        position="bottom-right" 
        toastOptions={{
          style: { 
            background: '#1f2937', 
            color: '#fff',
            border: '1px solid #374151'
          },
          duration: 4000,
        }} 
      />
      <AppProvider>
        <ClubProvider>
          <BrowserRouter>
            <ClubCacheManager />
            <NavigationWrapper>
              <Routes>
                {routes.map((route, index) => {
                  return (
                    <Route key={index} path={route.path} element={route.element} />
                  );
                })}
              </Routes>
            </NavigationWrapper>
          </BrowserRouter>
        </ClubProvider>
      </AppProvider>
    </div>
  )
}
